import { ChatsCircleIcon, XIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopStatusBubble, ScoopSpinner } from '../../../ui'
import styles from './HelpBotFab.module.scss'

export const HelpBotFab = ({ isOpen, hasUnread = false, isPending = false, onClick }) => {
    const showLoader = !isOpen && isPending
    const showUnread = !isOpen && !isPending && hasUnread

    return (
        <div className={styles.fabWrapper}>
            <ScoopButton
                variant="icon"
                className={`${styles.fab} ${isOpen ? styles.open : ''}`}
                onClick={onClick}
                aria-label={isOpen ? 'Close help chat' : 'Open help chat'}
                aria-expanded={isOpen}
            >
                <span className={`${styles.icon} ${!isOpen ? styles.visible : ''}`}>
                    <ChatsCircleIcon size={26} weight="fill" />
                </span>
                <span className={`${styles.icon} ${isOpen ? styles.visible : ''}`}>
                    <XIcon size={22} weight="bold" />
                </span>
            </ScoopButton>
            {showLoader && (
                <ScoopStatusBubble status="pending" size="small" className={styles.statusBubble}>
                    <ScoopSpinner size={14} />
                </ScoopStatusBubble>
            )}
            {showUnread && (
                <ScoopStatusBubble status="info" size="small" className={styles.statusBubble} />
            )}
        </div>
    )
}
